module.exports = __webpack_public_path__ + "static/media/info.0156141e.svg";